import { computed } from 'vue'
import { useStore } from 'vuex'
import Misc from 'src/utils/helper/misc'
import { head } from 'lodash'
export default{
  setup(){
    const store = useStore()

    const earningTotal = computed(() => store.getters['dashboard/getEarningTotal'])
    const topPerformingFamilies = computed(() => store.getters['dashboard/getTopPerformingFamilies'])
    const topPerformers = computed(() => topPerformingFamilies.value?.map(setFamilyBgColorWidth))

    const setFamilyBgColorWidth = family => {
      const totalEarning = head(earningTotal.value)?.amount
      const individualPerformerSalesAmount = head(family.totalSaleAmount)?.amount
      const currency = head(family.totalSaleAmount)?.currency
      const familyBgColorWidth = {
        ...family,
        saleAmount: Misc.getAmount(individualPerformerSalesAmount, currency),
        width: `${individualPerformerSalesAmount*(100/totalEarning)}%`
      }
      return familyBgColorWidth
    }

    return{
      earningTotal,
      topPerformingFamilies,
      topPerformers,
      setFamilyBgColorWidth
    }
  }
}
